export default "__VITE_ASSET__Do0PS$fT__"